import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { featureList } from '../helpers';
import { TICKETS_FEATURE_GROUP } from './group';

export { TICKETS_FEATURE_GROUP } from './group';

export const TICKETS_FEATURES = {
  READ: {
    guid: 'd9e4f7c2-3b58-4d71-9c36-7f1a2e4b0100',
    name: 'tickets:read',
    description: 'View the tickets workspace page',
    action: 'read',
    product: 'tickets',
    parentGuid: TICKETS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export const TICKETS_MODULE: FeatureModule = {
  product: 'tickets',
  groups: [],
  features: featureList(TICKETS_FEATURES),
};

export const ALL_TICKETS_MODULES: FeatureModule[] = [TICKETS_MODULE];

export const ALL_TICKETS_FEATURE_GROUPS: FeatureGroup[] = [
  TICKETS_FEATURE_GROUP,
  ...ALL_TICKETS_MODULES.flatMap((m) => m.groups),
];

export const ALL_TICKETS_FEATURES: Feature[] = ALL_TICKETS_MODULES.flatMap((m) => m.features);
